export default function ReferenceSVG() {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='70'
			zoomAndPan='magnify'
			viewBox='0 0 240 239.999995'
			height='70'
			preserveAspectRatio='xMidYMid meet'
			version='1.0'
		>
			<defs>
				<clipPath id='2f5768c96f'>
					<path
						d='M 102.042969 187.441406 L 102.792969 187.441406 L 102.792969 188.191406 L 102.042969 188.191406 Z M 102.042969 187.441406 '
						clipRule='nonzero'
					/>
				</clipPath>
				<clipPath id='8cf7174550'>
					<path
						d='M 101.664062 191.191406 L 103.152344 191.191406 L 103.152344 192.675781 L 101.664062 192.675781 Z M 101.664062 191.191406 '
						clipRule='nonzero'
					/>
				</clipPath>
				<clipPath id='6b1800fa8e'>
					<path
						d='M 102.40625 191.191406 C 101.996094 191.191406 101.664062 191.523438 101.664062 191.933594 C 101.664062 192.34375 101.996094 192.675781 102.40625 192.675781 C 102.816406 192.675781 103.152344 192.34375 103.152344 191.933594 C 103.152344 191.523438 102.816406 191.191406 102.40625 191.191406 Z M 102.40625 191.191406 '
						clipRule='nonzero'
					/>
				</clipPath>
				<clipPath id='cdc4e4c826'>
					<path
						d='M 101.664062 191.191406 L 103.148438 191.191406 L 103.148438 192.671875 L 101.664062 192.671875 Z M 101.664062 191.191406 '
						clipRule='nonzero'
					/>
				</clipPath>
				<clipPath id='3292fdc459'>
					<path
						d='M 102.40625 191.191406 C 101.996094 191.191406 101.664062 191.523438 101.664062 191.933594 C 101.664062 192.34375 101.996094 192.675781 102.40625 192.675781 C 102.816406 192.675781 103.148438 192.34375 103.148438 191.933594 C 103.148438 191.523438 102.816406 191.191406 102.40625 191.191406 Z M 102.40625 191.191406 '
						clipRule='nonzero'
					/>
				</clipPath>
				<clipPath id='fd2af270d7'>
					<path
						d='M 102.296875 191.566406 L 102.523438 191.566406 L 102.523438 192.363281 L 102.296875 192.363281 Z M 102.296875 191.566406 '
						clipRule='nonzero'
					/>
				</clipPath>
				<clipPath id='c0d7c2e5cc'>
					<path
						d='M 101.664062 195.375 L 103.152344 195.375 L 103.152344 196.859375 L 101.664062 196.859375 Z M 101.664062 195.375 '
						clipRule='nonzero'
					/>
				</clipPath>
				<clipPath id='0fc8391110'>
					<path
						d='M 102.40625 195.375 C 101.996094 195.375 101.664062 195.707031 101.664062 196.117188 C 101.664062 196.527344 101.996094 196.859375 102.40625 196.859375 C 102.816406 196.859375 103.152344 196.527344 103.152344 196.117188 C 103.152344 195.707031 102.816406 195.375 102.40625 195.375 Z M 102.40625 195.375 '
						clipRule='nonzero'
					/>
				</clipPath>
				<clipPath id='23bf86073a'>
					<path
						d='M 101.664062 195.375 L 103.148438 195.375 L 103.148438 196.855469 L 101.664062 196.855469 Z M 101.664062 195.375 '
						clipRule='nonzero'
					/>
				</clipPath>
				<clipPath id='0befb6d3d8'>
					<path
						d='M 102.40625 195.375 C 101.996094 195.375 101.664062 195.707031 101.664062 196.117188 C 101.664062 196.527344 101.996094 196.859375 102.40625 196.859375 C 102.816406 196.859375 103.148438 196.527344 103.148438 196.117188 C 103.148438 195.707031 102.816406 195.375 102.40625 195.375 Z M 102.40625 195.375 '
						clipRule='nonzero'
					/>
				</clipPath>
				<clipPath id='a68778e997'>
					<path
						d='M 102.296875 195.75 L 102.523438 195.75 L 102.523438 196.546875 L 102.296875 196.546875 Z M 102.296875 195.75 '
						clipRule='nonzero'
					/>
				</clipPath>
				<clipPath id='27e04acebc'>
					<path
						d='M 101.664062 199.558594 L 103.152344 199.558594 L 103.152344 201.042969 L 101.664062 201.042969 Z M 101.664062 199.558594 '
						clipRule='nonzero'
					/>
				</clipPath>
				<clipPath id='9cc85201f1'>
					<path
						d='M 102.40625 199.558594 C 101.996094 199.558594 101.664062 199.890625 101.664062 200.300781 C 101.664062 200.710938 101.996094 201.042969 102.40625 201.042969 C 102.816406 201.042969 103.152344 200.710938 103.152344 200.300781 C 103.152344 199.890625 102.816406 199.558594 102.40625 199.558594 Z M 102.40625 199.558594 '
						clipRule='nonzero'
					/>
				</clipPath>
				<clipPath id='1ad6da1a5c'>
					<path
						d='M 101.664062 199.558594 L 103.148438 199.558594 L 103.148438 201.039062 L 101.664062 201.039062 Z M 101.664062 199.558594 '
						clipRule='nonzero'
					/>
				</clipPath>
				<clipPath id='ea9f405159'>
					<path
						d='M 102.40625 199.558594 C 101.996094 199.558594 101.664062 199.890625 101.664062 200.300781 C 101.664062 200.710938 101.996094 201.042969 102.40625 201.042969 C 102.816406 201.042969 103.148438 200.710938 103.148438 200.300781 C 103.148438 199.890625 102.816406 199.558594 102.40625 199.558594 Z M 102.40625 199.558594 '
						clipRule='nonzero'
					/>
				</clipPath>
				<clipPath id='1df71b3d05'>
					<path
						d='M 102.296875 199.933594 L 102.523438 199.933594 L 102.523438 200.730469 L 102.296875 200.730469 Z M 102.296875 199.933594 '
						clipRule='nonzero'
					/>
				</clipPath>
				<clipPath id='891fdff1fa'>
					<path
						d='M 37.316406 0 L 208.316406 0 L 208.316406 240 L 37.316406 240 Z M 37.316406 0 '
						clipRule='nonzero'
					/>
				</clipPath>
			</defs>
			<g clipPath='url(#2f5768c96f)'>
				<path
					fill='#a6a6a6'
					d='M 102.460938 187.832031 L 102.816406 187.476562 C 102.828125 187.46875 102.828125 187.457031 102.816406 187.449219 C 102.808594 187.441406 102.796875 187.441406 102.789062 187.449219 L 102.433594 187.804688 L 102.078125 187.449219 C 102.070312 187.441406 102.058594 187.441406 102.050781 187.449219 C 102.042969 187.457031 102.042969 187.46875 102.050781 187.476562 L 102.40625 187.832031 L 102.050781 188.1875 C 102.042969 188.195312 102.042969 188.207031 102.050781 188.214844 C 102.058594 188.226562 102.070312 188.226562 102.078125 188.214844 L 102.433594 187.859375 L 102.789062 188.214844 C 102.792969 188.222656 102.796875 188.222656 102.804688 188.222656 C 102.808594 188.222656 102.8125 188.21875 102.816406 188.214844 C 102.828125 188.207031 102.828125 188.195312 102.816406 188.1875 Z M 102.460938 187.832031 '
					fillOpacity='1'
					fillRule='nonzero'
				/>
			</g>
			<g clipPath='url(#8cf7174550)'>
				<g clipPath='url(#6b1800fa8e)'>
					<path
						fill='#ffffff'
						d='M 101.664062 191.191406 L 103.152344 191.191406 L 103.152344 192.675781 L 101.664062 192.675781 Z M 101.664062 191.191406 '
						fillOpacity='1'
						fillRule='nonzero'
					/>
				</g>
			</g>
			<g clipPath='url(#cdc4e4c826)'>
				<g clipPath='url(#3292fdc459)'>
					<path
						strokeLinecap='butt'
						transform='matrix(0.056968, 0, 0, 0.056968, 101.665587, 191.192493)'
						fill='none'
						strokeLinejoin='miter'
						d='M 13.001372 -0.0190837 C 5.801611 -0.0190837 -0.0267671 5.809294 -0.0267671 13.009055 C -0.0267671 20.208816 5.801611 26.037194 13.001372 26.037194 C 20.201132 26.037194 26.02951 20.208816 26.02951 13.009055 C 26.02951 5.809294 20.201132 -0.0190837 13.001372 -0.0190837 Z M 13.001372 -0.0190837 '
						stroke='#eaeaeb'
						strokeWidth='26.330551'
						strokeOpacity='1'
						strokeMiterlimit='4'
					/>
				</g>
			</g>
			<g clipPath='url(#fd2af270d7)'>
				<path
					fill='#a6a6a6'
					d='M 102.40625 191.792969 C 102.46875 191.792969 102.519531 191.742188 102.519531 191.683594 C 102.519531 191.621094 102.46875 191.570312 102.40625 191.570312 C 102.347656 191.570312 102.296875 191.621094 102.296875 191.683594 C 102.296875 191.742188 102.347656 191.792969 102.40625 191.792969 Z M 102.296875 191.980469 L 102.296875 192.382812 L 102.519531 192.382812 L 102.519531 191.785156 L 102.296875 191.980469 '
					fillOpacity='1'
					fillRule='nonzero'
				/>
			</g>
			<g clipPath='url(#c0d7c2e5cc)'>
				<g clipPath='url(#0fc8391110)'>
					<path
						fill='#ffffff'
						d='M 101.664062 195.375 L 103.152344 195.375 L 103.152344 196.859375 L 101.664062 196.859375 Z M 101.664062 195.375 '
						fillOpacity='1'
						fillRule='nonzero'
					/>
				</g>
			</g>
			<g clipPath='url(#23bf86073a)'>
				<g clipPath='url(#0befb6d3d8)'>
					<path
						strokeLinecap='butt'
						transform='matrix(0.056968, 0, 0, 0.056968, 101.665587, 195.3732)'
						fill='none'
						strokeLinejoin='miter'
						d='M 13.001372 0.0316047 C 5.801611 0.0316047 -0.0267671 5.859982 -0.0267671 13.059743 C -0.0267671 20.259504 5.801611 26.087882 13.001372 26.087882 C 20.201132 26.087882 26.02951 20.259504 26.02951 13.059743 C 26.02951 5.859982 20.201132 0.0316047 13.001372 0.0316047 Z M 13.001372 0.0316047 '
						stroke='#eaeaeb'
						strokeWidth='26.330551'
						strokeOpacity='1'
						strokeMiterlimit='4'
					/>
				</g>
			</g>
			<g clipPath='url(#a68778e997)'>
				<path
					fill='#a6a6a6'
					d='M 102.40625 195.976562 C 102.46875 195.976562 102.519531 195.925781 102.519531 195.863281 C 102.519531 195.800781 102.46875 195.75 102.40625 195.75 C 102.347656 195.75 102.296875 195.800781 102.296875 195.863281 C 102.296875 195.925781 102.347656 195.976562 102.40625 195.976562 Z M 102.296875 196.164062 L 102.296875 196.5625 L 102.519531 196.5625 L 102.519531 195.964844 L 102.296875 196.164062 '
					fillOpacity='1'
					fillRule='nonzero'
				/>
			</g>
			<g clipPath='url(#27e04acebc)'>
				<g clipPath='url(#9cc85201f1)'>
					<path
						fill='#ffffff'
						d='M 101.664062 199.558594 L 103.152344 199.558594 L 103.152344 201.042969 L 101.664062 201.042969 Z M 101.664062 199.558594 '
						fillOpacity='1'
						fillRule='nonzero'
					/>
				</g>
			</g>
			<g clipPath='url(#1ad6da1a5c)'>
				<g clipPath='url(#ea9f405159)'>
					<path
						strokeLinecap='butt'
						transform='matrix(0.056968, 0, 0, 0.056968, 101.665587, 199.557878)'
						fill='none'
						strokeLinejoin='miter'
						d='M 13.001372 0.0125697 C 5.801611 0.0125697 -0.0267671 5.840948 -0.0267671 13.040708 C -0.0267671 20.240469 5.801611 26.068847 13.001372 26.068847 C 20.201132 26.068847 26.02951 20.240469 26.02951 13.040708 C 26.02951 5.840948 20.201132 0.0125697 13.001372 0.0125697 Z M 13.001372 0.0125697 '
						stroke='#eaeaeb'
						strokeWidth='26.330551'
						strokeOpacity='1'
						strokeMiterlimit='4'
					/>
				</g>
			</g>
			<g clipPath='url(#1df71b3d05)'>
				<path
					fill='#a6a6a6'
					d='M 102.40625 200.160156 C 102.46875 200.160156 102.519531 200.109375 102.519531 200.046875 C 102.519531 199.984375 102.46875 199.9375 102.40625 199.9375 C 102.347656 199.9375 102.296875 199.984375 102.296875 200.046875 C 102.296875 200.109375 102.347656 200.160156 102.40625 200.160156 Z M 102.296875 200.347656 L 102.296875 200.746094 L 102.519531 200.746094 L 102.519531 200.148438 L 102.296875 200.347656 '
					fillOpacity='1'
					fillRule='nonzero'
				/>
			</g>
			<g clipPath='url(#891fdff1fa)'>
				<path
					fill='#a6a6a6'
					d='M 206.707031 0.09375 L 39.21875 0.09375 C 38.167969 0.09375 37.316406 0.945312 37.316406 2 L 37.316406 238 C 37.316406 239.054688 38.167969 239.90625 39.21875 239.90625 L 206.707031 239.90625 C 207.757812 239.90625 208.609375 239.054688 208.609375 238 L 208.609375 2 C 208.609375 0.945312 207.757812 0.09375 206.707031 0.09375 Z M 204.804688 236.097656 L 41.125 236.097656 L 41.125 3.902344 L 204.804688 3.902344 Z M 87.910156 58.066406 C 88.960938 58.066406 89.8125 57.214844 89.8125 56.164062 L 89.8125 42.589844 L 94.527344 42.589844 L 101.789062 57.019531 C 102.125 57.683594 102.792969 58.066406 103.492188 58.066406 C 103.777344 58.066406 104.070312 58 104.34375 57.863281 C 105.285156 57.390625 105.660156 56.246094 105.1875 55.308594 L 98.570312 42.160156 C 102.515625 40.9375 105.390625 37.273438 105.390625 32.949219 C 105.390625 27.632812 101.042969 23.308594 95.699219 23.308594 L 87.910156 23.308594 C 86.859375 23.308594 86.003906 24.160156 86.003906 25.210938 L 86.003906 56.164062 C 86.003906 57.214844 86.855469 58.066406 87.910156 58.066406 Z M 89.8125 27.113281 L 95.699219 27.113281 C 98.945312 27.113281 101.585938 29.730469 101.585938 32.949219 C 101.585938 36.167969 98.945312 38.785156 95.699219 38.785156 L 89.8125 38.785156 Z M 119.070312 58.066406 C 121.992188 58.066406 124.71875 56.292969 126.546875 53.203125 C 127.085938 52.296875 126.785156 51.132812 125.882812 50.597656 C 124.976562 50.058594 123.808594 50.359375 123.273438 51.261719 C 122.144531 53.167969 120.613281 54.257812 119.070312 54.257812 C 116.269531 54.257812 113.855469 50.84375 113.300781 46.460938 L 126.859375 46.460938 C 127.910156 46.460938 128.761719 45.605469 128.761719 44.554688 C 128.761719 36.980469 124.503906 31.046875 119.070312 31.046875 C 113.632812 31.046875 109.375 36.980469 109.375 44.554688 C 109.375 52.132812 113.632812 58.066406 119.070312 58.066406 Z M 119.070312 34.851562 C 121.867188 34.851562 124.28125 38.265625 124.835938 42.652344 L 113.300781 42.652344 C 113.855469 38.265625 116.269531 34.851562 119.070312 34.851562 Z M 132.746094 38.753906 C 132.746094 37.703125 133.597656 36.851562 134.648438 36.851562 L 138.585938 36.851562 L 138.585938 31.015625 C 138.585938 26.765625 142.0625 23.308594 146.332031 23.308594 C 150.605469 23.308594 154.078125 26.765625 154.078125 31.015625 L 154.078125 32.949219 C 154.078125 34 153.226562 34.851562 152.175781 34.851562 C 151.125 34.851562 150.273438 34 150.273438 32.949219 L 150.273438 31.015625 C 150.273438 28.863281 148.503906 27.113281 146.332031 27.113281 C 144.160156 27.113281 142.394531 28.863281 142.394531 31.015625 L 142.394531 36.851562 L 146.332031 36.851562 C 147.382812 36.851562 148.238281 37.703125 148.238281 38.753906 C 148.238281 39.804688 147.382812 40.65625 146.332031 40.65625 L 142.394531 40.65625 L 142.394531 56.164062 C 142.394531 57.214844 141.542969 58.066406 140.492188 58.066406 C 139.441406 58.066406 138.585938 57.214844 138.585938 56.164062 L 138.585938 40.65625 L 134.648438 40.65625 C 133.597656 40.65625 132.746094 39.804688 132.746094 38.753906 Z M 148.324219 52.292969 C 148.324219 55.476562 150.925781 58.066406 154.125 58.066406 C 157.320312 58.066406 159.921875 55.476562 159.921875 52.292969 C 159.921875 49.113281 157.320312 46.523438 154.125 46.523438 C 150.925781 46.523438 148.324219 49.113281 148.324219 52.292969 Z M 154.125 50.328125 C 155.222656 50.328125 156.117188 51.210938 156.117188 52.292969 C 156.117188 53.378906 155.222656 54.257812 154.125 54.257812 C 153.027344 54.257812 152.132812 53.378906 152.132812 52.292969 C 152.132812 51.210938 153.023438 50.328125 154.125 50.328125 Z M 64.808594 90.726562 C 64.3125 89.800781 64.65625 88.644531 65.582031 88.148438 C 66.507812 87.648438 67.660156 87.996094 68.160156 88.917969 L 72.136719 96.292969 L 82.265625 72.820312 C 82.683594 71.855469 83.804688 71.410156 84.765625 71.828125 C 85.734375 72.242188 86.175781 73.363281 85.761719 74.328125 L 74.074219 101.410156 C 73.785156 102.078125 73.140625 102.527344 72.410156 102.558594 C 72.382812 102.558594 72.355469 102.558594 72.328125 102.558594 C 71.628906 102.558594 70.984375 102.175781 70.652344 101.558594 Z M 101.539062 85.210938 L 179.441406 85.210938 C 180.492188 85.210938 181.34375 86.0625 181.34375 87.113281 C 181.34375 88.164062 180.492188 89.015625 179.441406 89.015625 L 101.539062 89.015625 C 100.488281 89.015625 99.636719 88.164062 99.636719 87.113281 C 99.636719 86.0625 100.488281 85.210938 101.539062 85.210938 Z M 64.808594 135.21875 C 64.3125 134.292969 64.65625 133.136719 65.582031 132.640625 C 66.507812 132.140625 67.660156 132.484375 68.160156 133.410156 L 72.136719 140.785156 L 82.265625 117.3125 C 82.683594 116.347656 83.804688 115.902344 84.765625 116.320312 C 85.734375 116.734375 86.175781 117.855469 85.761719 118.820312 L 74.074219 145.902344 C 73.785156 146.574219 73.140625 147.019531 72.410156 147.050781 C 72.382812 147.050781 72.355469 147.050781 72.328125 147.050781 C 71.628906 147.050781 70.984375 146.667969 70.652344 146.050781 Z M 181.34375 131.605469 C 181.34375 132.65625 180.492188 133.511719 179.441406 133.511719 L 101.539062 133.511719 C 100.488281 133.511719 99.636719 132.65625 99.636719 131.605469 C 99.636719 130.554688 100.488281 129.703125 101.539062 129.703125 L 179.441406 129.703125 C 180.492188 129.703125 181.34375 130.554688 181.34375 131.605469 Z M 64.808594 179.710938 C 64.3125 178.785156 64.65625 177.632812 65.582031 177.132812 C 66.507812 176.632812 67.660156 176.980469 68.160156 177.902344 L 72.136719 185.277344 L 82.265625 161.804688 C 82.683594 160.839844 83.804688 160.394531 84.765625 160.8125 C 85.734375 161.226562 86.175781 162.347656 85.761719 163.3125 L 74.074219 190.394531 C 73.785156 191.066406 73.140625 191.511719 72.410156 191.542969 C 72.382812 191.542969 72.355469 191.542969 72.328125 191.542969 C 71.628906 191.542969 70.984375 191.164062 70.652344 190.542969 Z M 181.34375 176.097656 C 181.34375 177.152344 180.492188 178.003906 179.441406 178.003906 L 101.539062 178.003906 C 100.488281 178.003906 99.636719 177.152344 99.636719 176.097656 C 99.636719 175.046875 100.488281 174.195312 101.539062 174.195312 L 179.441406 174.195312 C 180.492188 174.195312 181.34375 175.046875 181.34375 176.097656 Z M 181.34375 176.097656 '
					fillOpacity='1'
					fillRule='nonzero'
				/>
			</g>
		</svg>
	);
}
